<progress-spinner *ngIf="validationInProgress"></progress-spinner>
<mat-dialog-content *ngIf="!validationInProgress">
  <!-- Content will only show when validation is done -->
  <div *ngIf="!validationInProgress" class="content-container">
    <!-- Renaming Summary before renaming starts -->
    <div *ngIf="!renamingInProgress && !renamingJobStatus">
      <!-- <h3>Renaming Summary</h3> -->
      <div class="modal-header">
        <div class="title">
          <span class="header">Apply File {{ applyingFileName }}</span>
        </div>
        <div class="btn-group" (click)="closeDialog()">
          <i class="mdi mdi-close close-icon"></i>
        </div>
      </div>
      <mat-list *ngIf="!errorOnValidationProcess">
        <mat-list-item *ngFor="let summary of renamingSummary">
          {{ summary.summaryTxt }}
        </mat-list-item>
      </mat-list>
      <mat-list *ngIf="errorOnValidationProcess">
        <mat-list-item>
          {{ errorOnValidationProcess }}
        </mat-list-item>
      </mat-list>
      <div class="proceed-text" *ngIf="!errorOnValidationProcess">Would you like to proceed?</div>
    </div>

    <!-- Progress bar during renaming process -->
    <div class="progress-status" *ngIf="renamingInProgress && !renamingJobStatus">
      <p>{{ renamingJobProgressMsg }}</p>
      <mat-progress-bar mode="determinate" [value]="renamingCompletedPercent"></mat-progress-bar>
    </div>

    <!-- Renaming Job status after completion -->
    <div *ngIf="!renamingInProgress && renamingJobStatus">
      <div class="modal-header">
        <div class="title">
          <span class="header">Apply File {{ applyingFileName }}</span>
        </div>
        <div class="btn-group" (click)="closeDialog()">
          <i class="mdi mdi-close close-icon"></i>
        </div>
      </div>
      <p>{{ renamingJobStatus }}</p>
      <mat-list>
        <mat-list-item *ngFor="let summary of renamingSummary">
          {{ summary.summaryTxt }}
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!validationInProgress" align="center">
  <!-- Cancel button always available unless loading -->
  <div class="btn-group">
    <button
      mat-button
      class="save-btn cancel"
      *ngIf="!validationInProgress && renamingInProgress && !errorOnValidationProcess"
      (click)="closeDialog()"
    >
      Cancel
    </button>

    <button
      mat-button
      class="save-btn cancel"
      *ngIf="
        validationInProgress || renamingInProgress || renamingJobStatus || errorOnValidationProcess
      "
      (click)="closeDialog()"
    >
      Close
    </button>

    <!-- Proceed button visible only when renaming hasn't started yet -->
    <button
      mat-flat-button
      class="save-btn"
      *ngIf="
        !validationInProgress &&
        !renamingInProgress &&
        !renamingJobStatus &&
        !errorOnValidationProcess
      "
      (click)="proceedBulkRenamingAction()"
    >
      Apply
    </button>

    <!-- View Results button after renaming completes -->
    <button
      mat-button
      class="save-btn cancel"
      *ngIf="isRenamingJobCompleted"
      (click)="viewRenamingResult()"
    >
      View Results
    </button>
  </div>
</mat-dialog-actions>
